import { ActivityIndicator, StyleSheet, View } from 'react-native';

import colors from '@/config/colors';

const styles = StyleSheet.create({
  loadingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(255,255,255, 0.7)',
    position: 'absolute',
    right: 0,
    left: 0,
    top: 0,
    bottom: 0,
    zIndex: 9999,
  },
});

function LoadingIndicator({ showLoading }) {
  if (showLoading) {
    return (
      <View style={styles.loadingContainer}>
        <ActivityIndicator size="large" color={colors.primary} />
      </View>
    );
  } else {
    return <View />;
  }
}

export default LoadingIndicator;
